import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";

// Empty placeholder slice: reserves the `settings` key in the store shape (see Reducers.ts) for
// future cross-page settings state. Nothing reads or writes it today : /settings is API-backed.

export interface ISettingsState {
}

export const slice = createSlice({
    name: "settings",
    initialState: {

    } as ISettingsState,
    reducers: {

    },
});

export const { reducer } = slice;

export const actionCreators = {

};

export const { } = slice.actions;
